



jQuery(()=>{
    let customSelectSelector = '.custom-select';
    let customSelect = jQuery(customSelectSelector);

    let originalSelect = jQuery('select', customSelect);

    let selectedOptionElementSelector = customSelectSelector+'__selected';
    let selectedOptionElement = jQuery(selectedOptionElementSelector);

    let dropDownSelector = customSelectSelector+'__drop-down';
    let dropDown = jQuery(dropDownSelector);

    function toggleDropDown()
    {
        let showClass = dropDownSelector.substring(1)+'--show';

        if(dropDown.hasClass(showClass))
        {
            dropDown.removeClass(showClass);
            return;
        }

        dropDown.addClass(showClass);
    }

    function hideDropDown()
    {
        dropDown.removeClass(dropDownSelector.substring(1)+'--show');
    }

    function removeSelectedColours()
    {
        jQuery('.colour-picker__colour').removeClass('colour-picker__colour--selected');
    }

    function showSelectedColour(variant: string)
    {
        removeSelectedColours();
        jQuery('.colour-picker').find(`[value="${variant}"]`).addClass('colour-picker__colour--selected');
    }

    selectedOptionElement.on('click', ()=>{
        toggleDropDown();
    });

    jQuery(customSelectSelector+'__option').on('click', (e)=>{
        let optionSelected = jQuery(e.currentTarget);
        let value = optionSelected.attr('value');
        // @ts-ignore
        customSelect.attr('value', value);
        selectedOptionElement.html(optionSelected.html());
        originalSelect.val(value);
        originalSelect.trigger('change');
        hideDropDown();
        showSelectedColour(value);
    });

    jQuery('.colour-picker__colour').on('click', (e)=>{
        let optionSelected = jQuery(e.currentTarget);
        let value = optionSelected.attr('value');
        // @ts-ignore
        customSelect.attr('value', value);
        selectedOptionElement.html(jQuery('.custom-select__drop-down').find(`[value="${value}"]`).html());
        originalSelect.val(value);
        originalSelect.trigger('change');
        hideDropDown();
        showSelectedColour(value);
    })

    jQuery('.variations_form').on('woocommerce_update_variation_values', ()=>{
        let options = dropDown.find('.custom-select__option');
        let originalOptions = [];

        originalSelect.find('option').each((index, element)=>{
            originalOptions.push(jQuery(element).val());
        });

        options.each((index, element)=>{
            let option = jQuery(element);
            if(!originalOptions.includes(option.attr('value')))
            {
                option.remove();
            }
        });
    })

    jQuery('.variations_form').on('reset_data', ()=>{
        customSelect.attr('value', '');
        selectedOptionElement.html('Make a selection');
        removeSelectedColours();
    });

});